import { gql } from '@apollo/client'

export const GET_ORDER_DETAILS = gql`
  query getOrderDetails($id: ID!, $organisationId: ID, $employeeId: ID) {
    caseItem(
      id: $id
      organisationId: $organisationId
      employeeId: $employeeId
    ) {
      id
      created
      caseType
      status
      customerLabel
      poRcn
      customClientReference
      billingIdentifier
      tags {
        id
        name
        color
        inherited
        inheritedFrom
      }
      data {
        message
        requestedDevice {
          name
        }
        deviceDefinition {
          id
          name
          productType
          imageURL
        }
        fromRentCategory {
          upgradeAmount
        }
        requestedRentCategory {
          deviceDefinition {
            name
            productType
            imageURL
          }
          rentCategory {
            name
            copaymentNet
            displayedBasisAmount
          }
        }
        requestedRentCategoryCheckout {
          message
        }
        requestedPhonePlan {
          name
          number
          employees
        }
        requestedShippingAddress {
          city
          country
          name
          nameAddition
          street
          streetAddition
          zipcode
        }
        requestedOfferOrder {
          copaymentPrice
          basePrice
        }
        isReplacementRequested
      }
      subCaseItems {
        caseType
        rental {
          id
          stocklistItem {
            id
            imei
            imei2
          }
          deviceDefinition {
            name
            productType
            imageURL
          }
        }
      }
      assignedEmployee {
        id
        contact {
          firstName
          lastName
          email
          phoneNumber
        }
      }
      assignedUser {
        firstName
        lastName
      }
      updateMessages {
        updateMessages {
          id
          userId
          created
          message
        }
      }
      rental {
        id
        deviceID
        earliestContractTermination
        employee {
          contact {
            firstName
            lastName
          }
        }
        startAt
        costCenter {
          name
        }
        rentCategory {
          copaymentNet
          displayedBasisAmount
        }
        stocklistItem {
          id
          imei
          imei2
        }
        deviceDefinition {
          name
          productType
          imageURL
        }
      }
      phonePlan {
        id
        simcardNumber
        startAt
        endAt
        phonePlanTariff {
          name
        }
      }
      user {
        id
        firstName
        lastName
      }
      caseItemShipping {
        trackingURL
        serviceProvider
        trackingReference
        performedAt
      }
      shipping {
        trackingURL
        serviceProvider
        trackingReference
        performedAt
      }
      trackingStatuses {
        totalCount
        trackingStatuses {
          status
          created
        }
      }
      generatedQRCode
      offerOrderItem {
        customDeviceName
        addonType
      }
      externalCaseId
      parentCaseItem {
        externalCaseId
      }
    }
  }
`

export const GET_ORDER_LIST_PREVIEW_COLUMN = gql`
  query getOrderListPreviewColumn($id: ID!) {
    caseItem(id: $id) {
      id
      created
      caseType
      status
      data {
        requestedDevice {
          name
        }
        requestedRentCategory {
          deviceDefinition {
            codename
            manufacturer
            productType
            imageURL
            name
          }
          rentCategory {
            copaymentNet
            displayedBasisAmount
          }
        }
        requestedOfferOrder {
          copaymentPrice
          basePrice
          deviceDefinition {
            name
          }
        }
        requestedPhonePlan {
          name
        }
      }
      assignedUser {
        firstName
        lastName
      }
      rental {
        stocklistItem {
          id
          imei
          imei2
          serialNumber
          eid
        }
      }
      generatedQRCode
      offerOrderItem {
        customDeviceName
        addonType
      }
      externalCaseId
      parentCaseItem {
        externalCaseId
      }
    }
  }
`
